import { jsx } from "react/jsx-runtime";
import { gridClasses } from "@mui/x-data-grid-pro";
import { forwardRef } from "react";
const DataTableExpandableCell_DataTableExpandableCell = /*#__PURE__*/ forwardRef(function({ children }, ref) {
    return /*#__PURE__*/ jsx("div", {
        className: gridClasses.cellContent,
        ref: ref,
        role: "presentation",
        children: children
    });
});
export { DataTableExpandableCell_DataTableExpandableCell as DataTableExpandableCell };

//# sourceMappingURL=DataTableExpandableCell.js.map